var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.504 4.0625C10.6985 4.06256 10.8596 4.12876 10.9893 4.26172C11.1193 4.39506 11.1846 4.55821 11.1846 4.75195V9.31543H15.7481C15.9416 9.31543 16.104 9.38142 16.2374 9.51367C16.3708 9.64588 16.4376 9.80893 16.4376 10.0039C16.4375 10.1987 16.3716 10.3605 16.2383 10.4902C16.105 10.6202 15.9418 10.6846 15.7481 10.6846H11.1846V15.248C11.1846 15.442 11.1186 15.6039 10.9864 15.7354C10.8542 15.8669 10.6912 15.9326 10.4962 15.9326C10.3012 15.9326 10.1396 15.8667 10.0098 15.7354C9.88017 15.6039 9.81549 15.4421 9.81549 15.248V10.6846H5.25201C5.05806 10.6846 4.89619 10.6185 4.76471 10.4863C4.63319 10.3541 4.56744 10.1912 4.56744 9.99609C4.56748 9.80127 4.63244 9.63948 4.76373 9.50977C4.89521 9.37989 5.05784 9.31543 5.25201 9.31543H9.81549V4.75195C9.81549 4.55847 9.88146 4.39602 10.0137 4.2627V4.26172C10.1459 4.12845 10.3091 4.0625 10.504 4.0625Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5a708ffb15c871aed3e041a192dafb67.svg";
export { ForwardRef as ReactComponent };